// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"36":"1da485ba","44":"4e41379b","198":"7ec33edd","365":"f6713c56","670":"eb4102eb","726":"fcce104c","738":"065be641","941":"336028a3","947":"e2731617","954":"4d165d6b"}[chunkId] + ".js";
};